export default __webpack_public_path__ + "images/47a0b242-avatar.svg";